import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';

export type PostLoginResponse = {
    jwt: string;
    refreshCode: string;
    longLivedToken: string;
    validFor: number;
};

const impersonateUrls = {
    impersonate: urlBuilder('auth', 'impersonate/liftoperator'),
};

export const impersonateApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        postImpersonate: builder.mutation<
            PostLoginResponse,
            { liftOperatorId: string }
        >({
            query: ({ liftOperatorId }) => ({
                method: 'POST',
                url: impersonateUrls.impersonate,
                body: {
                    id: liftOperatorId,
                },
            }),
        }),
    }),
});

export const { usePostImpersonateMutation } = impersonateApi;
